module.exports = __webpack_public_path__ + "07_face.5ac736cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer1/07_face.png
// module id = bR4s
// module chunks = 0